import React from "react";
import { Field } from "formik";
import CustomDatepicker from "./custom-datepicker";
import FormFieldError from "components/form/form-field-error";
import { formikPropTypes } from "components/common";
import defaultDatepickerProptypes from "./default-proptypes";

const CustomFormDatepicker = ({ field, ...props }) => (
  <>
    <CustomDatepicker onChange={field.onChange} value={field.value} {...props} />
    <FormFieldError name={field.name} />
  </>
);

CustomFormDatepicker.propTypes = {
  ...formikPropTypes,
  ...defaultDatepickerProptypes,
};

const FormDatepicker = ({ name, onChange, value, onBlur, ...props }) => (
  <Field
    component={CustomFormDatepicker}
    field={{
      name,
      onChange: onChange(name),
      value,
      onBlur,
    }}
    {...props}
  />
);

FormDatepicker.propTypes = {
  ...defaultDatepickerProptypes,
};

export default FormDatepicker;
